import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { DashboardRoutesEnum } from '@constants/enums/Routes.enum';
import { useFetchProfileQuery } from '@gql/types';

export const OnboardingGuard: FC = () => {
  const { data, loading } = useFetchProfileQuery();
  const user = data?.fetchProfile ?? null;

  if (loading || !user) return null;

  if (user.onboarding !== 'FINISHED') {
    return <Navigate to={`/${DashboardRoutesEnum.ONBOARDING_ROUTE}`} replace />;
  }

  return <Outlet />;
};
